import { IMuWidget } from "./IMuWidget";
import {InvoiceApprovalCL} from "./generated/InvoiceApprovalCL";
import {
	ApprovingSchema, ApprovingEntity,
	GetInvoiceResponse,
	Invoice,
	InvoiceItem, InvoiceItemApproval,
	InvoiceState,
	SetStateUid
} from "./InvoiceTypes";
import {AccountSelector} from "./AccountSelector";
import {UiFlashMessage} from "./UiFlashMessage";
import {TreeSelector} from "./TreeSelector";
import {Account} from "./CommonTypes";
import {SearchSelector} from "./SearchSelector";
import {CachedPromise} from "./CachedPromise";
import {BaseMuWidget} from "./BaseMuWidget";
import {MuBinder} from "mu-widget/lib/MuBinder";
import {MuNamedWidgets, MuUi, MuWidget} from "mu-widget/lib/MuWidget";
import {flashInfo, getRadioListSelectedValue, Utils} from "./Utils";
import {UiTomSelect} from "./components/UiTomSelect";
import {UiModalContainer} from "./UiModalContainer";
import {UiAttaches} from "./UiAttaches";
import {TicketEventRes} from "./ticketOverview/TOInvoiceApproving";
// import * as FFF from "./MultiUpload";

export class InvoiceApproval extends BaseMuWidget
{
	// @ts-ignore
	public mode: InvoiceApprovalFormMode;

	// @ts-ignore
	public myAccountId: number;

	// @ts-ignore
	public clUrl : string;

	// @ts-ignore
	public cl: InvoiceApprovalCL;

	// @ts-ignore
	public invoiceId: number;

	// @ts-ignore
	public productRequired: boolean;

	// @ts-ignore
	public ticketId: number;

	private accounts : Record<number, Account> = {};

	// @ts-ignore
	private approvingSchemas: Record<number, ApprovingSchema>;

	// @ts-ignore
	private currentItemId: number|"invoice";

	// @ts-ignore
	private invoice: Invoice;

	// @ts-ignore
	private approvingSchemaId: number;

	// @ts-ignore
	private currentEntity: ApprovingEntity;

	// @ts-ignore
	public buSubjectId: number;

	public static readonly stateIcons: Record<InvoiceState, string> = {
		accepted: 'checked-on',
		noproduct: 'question-blue',
		noschema: 'question',
		wait: 'checked-off',
		"my-wait": 'checked-off',
		rejected: 'no'
	}
	// @ts-ignore
	private invoiceApprovalItem: InvoiceApprovalItem;

	// @ts-ignore
	private schemaByProjectDivision: Record<string, number|null>;

	// @ts-ignore
	private sumWidget: IMuWidget;

	// @ts-ignore
	private ticketStateCode: "state3"|"returned"|"rejected"|"new"|"inProgress"|"accepted";

	private async saveIfNew(): Promise<boolean> {
		for(const widget of this.getItemWidgets()) {
			if (!widget.muFetchData().id) {
				await this.doSave(false);
				return true;
			}
		}

		return false;
	}

	beforeIndex() {
		// this.container.innerHTML = '<div mu-widget="UiInvoiceSplitItem"></div>' + this.container.innerHTML;
	}

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		attaches: UiAttaches
	}>;

	public afterIndex() {
		super.afterIndex();
		this.cl = new InvoiceApprovalCL(); // this.clUrl);
		this.cl.context.invoiceId = this.invoiceId;
		this.cl.context.ticketId = this.ticketId;
		/* (this.muNamedWidget.cApprovers as AccountSelector).searchCallback = (term, resolve) => {
			this.cl.findAccounts(term).then(data => {
				resolve(data);
			});
		};*/
		this.reloadInvoice();
		this.openApproving(false);
		this.container.classList.remove("loading");
		this.muVisible(this.mode == "approving" || this.mode == "complete", "pInvoiceHeader");
		// this.bindAttachList();
		// this.bClosePreview_click();
		this.muNamedWidget.attaches.ticketId = this.ticketId;
		this.muNamedWidget.attaches.loadAttaches();
		this.openInvItemSelectSchema(false);
		this.callMethodInFirstAncestors(
			'setFormChangedCallback',
			() => this.isChanged()
		);
	}

	private lastData: string = "";

	public setIsSaved() {
		this.lastData = this.getStateHash();
	}

	public isChanged() {
		return this.lastData !== this.getStateHash();
	}

	public getStateHash(): string {
		return JSON.stringify(this.getItemWidgets().map(iiw => iiw.muFetchData()));
	}

	public getAccountName(id: number) {
		return this.accounts[id].name;
	}
	/* public getOrgDivisions() : Promise<any> {
		return new Promise<any>(resolve => {
			if (this.orgDivisions) resolve(this.orgDivisions);
			else {
				if (!this.orgDivisionPromise) this.orgDivisionPromise = this.cl.getOrgDivisions();
				this.orgDivisionPromise.then(res => {
					this.orgDivisions = res;
					resolve(this.orgDivisions);
				});
			}
		});
	}
	protected orgDivisions = null;
	protected orgDivisionPromise = null; */

	public orgDivisionPromise = new CachedPromise(() => this.cl.withMessage('Načítám organizační jednotky').getOrgDivisions(this.buSubjectId, true));
	public orgProjectPromise = new CachedPromise(() => this.cl.withMessage('Načítám projekty').getOrgProjects(this.buSubjectId, true));
	public orgProductPromise = new CachedPromise(() => this.cl.withMessage('Načítám produkty').getOrgProducts(this.buSubjectId, true));

	protected lastTicketStateId: number|null = null;

	public async loadInvoice() : Promise<void> {
		const checkedIds = this.getCheckedItemIds();
		this.container.classList.toggle('loading-data', true);
		if (this.invoiceId) {
			const data = await this.cl.withMessage('Načítám fakturu').getInvoice(this.invoiceId);
			this.bindInvoiceData(data);
			this.container.classList.toggle('loading-data', false);
			if (this.lastTicketStateId !== null && this.lastTicketStateId !== data.ticketStateId) {
				this.callMethodInFirstAncestors('onApprovingStateChange');
			}
			this.lastTicketStateId = data.ticketStateId;
			this.updateForm();
			this.muBindData({
				rejectInfo: this.getRejectInfo()
			});

		}
		this.setIsSaved();
	}

	public bindInvoiceData(data: any) {
		this.bindInvoice(data);
		this.ticketStateCode = data.ticketStateCode;
		//todo: Odprasit
		const accountIdsToNames = (ids: number[]) => ids.map(id => data.accounts[id].name).join(', ');

		const infoData = {
			'[data-rolecode="approver"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverActiveIds),
			// '[data-rolecode="approver.inactive"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverInactiveIds),
			'[data-rolecode="approver.next"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverNextIds),
			'[data-rolecode="approver.prev"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverPrevIds),
			'[data-rolecode="approver.reject"] [mu-id="selectedContainer"]': accountIdsToNames(data.approverRejectIds),
			".detail-state strong": data.ticketStateName
		};
		for(var q in infoData) {
			const el = document.querySelector(q) as HTMLElement;
			if (el) el.innerText = infoData[q];
		}
		// const el = document.querySelector(".detail-state strong") as HTMLElement;
		// if (el) el.innerText = data.ticketStateName;

		const mApproving = this.mode !== "schema";
		const mSchema = this.mode !== "approving";

		// Schvalování celé faktury
		/* this.muVisible(
			data.invoice.approving.state === "wait" && data.invoice.approving.approverIds?.includes(this.myAccountId) && mApproving,
			[ "bInvApprove", "bInvReject", "pInvComment" ]
		);
		this.muVisible(
			data.invoice.approving.state !== "noschema",
			"bInvApprovingDetail"
		);
		this.muVisible(
			data.invoice.approving.state === "noschema" && mSchema,
			"bInvSelectSchema"
		);
		*/
	}

	private bindInvoice(data: GetInvoiceResponse) {
		this.accounts = data.accounts;
		this.invoice = data.invoice;
		const ids = data.checkedIds;
		this.muBindData({
			...data.invoice,
			ticketStateName: data.ticketStateName,
			returnInfo: data.returnInfo,
		});
		if (ids?.length) this.selectAll(new Event(""), ids);
		this.approvingSchemas = data.approvingSchemas;
	}

	override muBindData(srcData: any) {
		super.muBindData(srcData);
		if ("items" in srcData) this.bindItems(srcData.items);
	}

	public updateForm() {
		const formOptions: FormOptions = this.callMethodInFirstAncestors('getFormOptions');
		// vypnuté schvalování
		const noApproving = !!formOptions.noApproving || ![ "new", "inProgress" ].includes(this.ticketStateCode);
		// zákaz všech úprav
		const readOnly = typeof formOptions.readOnly === "string"
			? formOptions.readOnly !== this.ticketStateCode
			: formOptions.readOnly;
		const items = this.getCheckedItems();
		this.muVisible(false && items.length > 0, "bApproving");
		const firstItem = items.length > 0 ? items[0] : null;
		const firstItemState = firstItem?.approving?.state;
		this.getItemWidgets()
			.forEach(iiw => iiw.visibleCheckedIfState(firstItemState));
		// položky - schválit/zamítnout
		/* this.muVisible(
			firstItemState === "wait"
				&& firstItem.approving?.approverIds?.includes(this.myAccountId),
			[
				// 'bInvItemApprove',
				// 'pInvComment',
			]
		); */

		this.muVisible(false, "bReload");

		if (readOnly) {
			this.muVisible(false, [
				'bInvItemRejectDialog',
				'bInvItemCancelDialog',
				'bInvItemReject',
				'bInvItemCancel',
				'pInvComment',
				'bInvItemApprove',
				"bInvStartApproving",
				"bSaveAndApprove",
				"bSave",
				"bReturn",
			]);

		} else {
			const anyMy = this.selectAll(null, "my-wait", false).length > 0;
			this.muVisible(anyMy && !noApproving, [
				'bInvItemRejectDialog',
				'bInvItemCancelDialog',
			]);
			this.muVisible(false, [
				'bInvItemReject',
				'bInvItemCancel',
				'pInvComment',
				'bInvItemApprove',
			]);
			this.muVisible(
				firstItemState === "noschema"
					&& !this.getItemWidgets(true).some(iiw => !iiw.getOrgProjectId() || (!iiw.getOrgProductId() && this.productRequired)),
				"bInvStartApproving" // "bInvItemSelectSchema"
			);

			const isApproving = this.getItemWidgets(null).some(iiw => iiw.isEditable());
			this.muVisible(
				isApproving && !noApproving,
				"bSaveAndApprove"
			);
			this.muVisible(
				false, // this.ticketStateCode === "rejected",
				"bReturn"
			);
			const anyNoProduct = this.getItemWidgets(null).some(iiw => !iiw.getOrgProductId())
			/* this.muVisible(
				anyNoProduct,
				"bInvRequireProduct"
			); */
			const anyNoOldProduct = true; // dostupné furt pro možnost změny this.getItemWidgets(null).some(iiw => !iiw.oldOrgProductId);
			this.muVisible(isApproving || anyNoOldProduct, "bSave");
		}
	}

	public getItemWidgets(checked: boolean|null = null): InvoiceApprovalItem[] {
		return this.muGetChildWidgets<InvoiceApprovalItem>("items")
			.filter(iw => iw instanceof InvoiceApprovalItem && (typeof checked !== "boolean" || iw.isChecked() === checked))
	}

	private getCheckedItems() : InvoiceItem[] {
		return this.getItemWidgets()
			.filter((ii) => ii.isChecked())
			.map(ii => ii.invoiceItem);
	}

	private getCheckedItemWidgets() : InvoiceApprovalItem[] {
		return this.getItemWidgets()
			.filter((ii) => ii.isChecked());
	}

	private getCheckedItemIds() : number[] {
		return this.getCheckedItems().map(ii => ii.id);
	}

	private getApprovingItemIds() : number[] {
		return this.getApprovingItem().map(ii => ii.invoiceItem.id);
	}

	private getApprovingItem() : InvoiceApprovalItem[] {
		return this.muGetChildWidgets<InvoiceApprovalItem>("approvingItems");
	}

	openInvItemSelectSchema(visible: boolean) {
		this.muVisible(visible, [ "pInvItemApprovingSchemaList", "!pButtons" ]);
	}

	bInvItemSelectSchema_click() {
		this.openInvItemSelectSchema(true);
		this.loadApprovingSchemas();
	}

	async bInvStartApproving_click() {
		const items = this.getCheckedItemWidgets();
		const projectDivisionIds = items.map(iiw => {
			const opid = iiw.getOrgProjectId();
			return {
				orgProjectId: opid === "withoutProject" ? null : opid,
				orgDivisionId: iiw.getOrgDivisionId(),
			};
		});
		this.schemaByProjectDivision = await this.cl.withMessage("Hledám schvalovací schémata").getApprovingSchemaForOrgProjectIds(projectDivisionIds);
		const anyNoSetting = Object.values(this.schemaByProjectDivision).some(n => n === null);
		// Uložit
		await this.doSave(false, false);
		// Spustit schvalování
		if (anyNoSetting) {
			this.openInvItemSelectSchema(true);
			this.loadApprovingSchemas();
		} else {
			this.createApproving(null);
		}
	}

	getRejectInfo(): { account: string, note: string, dt: string }[]
	{
		const res = [];
		for(const item of this.invoice.items) {
			if  (item.approving.state === "rejected") {
				for (const approval of item.approving.approvals) {
					if (approval.state === "rejected") {
						res.push({
							account: this.accounts[approval.accountId].name,
							note: approval.note,
							dt: approval.createdAt,
						});
					}
				}
			}
		}

		return res;
	}

	bInvItemCreateApprovingCancel_click() {
		this.openInvItemSelectSchema(false);
	}

	approveItems(invoiceItems: InvoiceItem[]|Invoice) {
		let approving : InvoiceItemApproval;
		let isItems : boolean = false; // = Array.isArray(invoiceItems);
		if (Array.isArray(invoiceItems))
		{
			isItems = true;
			// Položky faktury
			this.muClear("approvingItems");
			for(let item of invoiceItems) {
				const w = this.muWidgetFromTemplate("invoiceItem", "approvingItems", { inApproving: true });
				w.muBindData(item);
				approving = item.approving;
			}
		} else {
			// Celá faktura
			approving = invoiceItems.approving;
		}
		this.currentEntity = isItems ? "invoiceItem" : "invoice";
		this.muVisible(isItems, ["invoiceItemTable", "!approvingInvoiceLabel"]);
		this.setApprovingPhase("actions");
		const state = approving.state;
		const isMy = approving.approverIds?.includes(this.myAccountId);
		this.muVisible(state === "wait" && isMy, ["bAccept", "bReject", "bOpenSetApprover"]);
		this.muVisible(state === "noschema", "bOpenSetApprovingSchemaList");
		this.muVisible(false /*state === "rejected"*/, "bReopen");
		this.openApproving(true);
		// Přejít na výběr schématu pokud je bez schématu
		if (state === "noschema") this.bOpenSetApprovingSchemaList_click();
	}

	public bApproving_click() {
		this.approveItems(this.getCheckedItems())
	}

	public bAccept_click() {
		this.setState("accepted", "invoiceItem");
	}

	public bReject_click() {
		this.setState("rejected", "invoiceItem");
	}

	bInvItemApprove_click() {
		this.doSave(false).then(
			() => this.setState("accepted", "invoiceItem")
		);
	}

	bInvItemReject_click() {
		this.doSave(false).then(
			() => this.setState("rejected", "invoiceItem")
		);
	}

	async bInvItemCancel_click() {
		await this.invoiceItemsCancel(await this.getCheckedItemWidgets());
	}

	async invoiceItemsCancel(items: InvoiceApprovalItem[]) {
		const itemIds = [];
		for(const item of items)
		{
			const groupIds = this.checkRemoveApprover(item.invoiceItem, this.myAccountId);
			// zkus jen odebrat řešitele
			if (groupIds !== false) {
				// odebrat řešitele
				itemIds.push({
					invoiceItemId: item.invoiceItem.id,
					groupIds: groupIds,
				});
			} else {
				// zrušit schvalování
				item.setOrgProjectId(null);
			}
		}
		// return;
		await this.doSave(false);
		if (itemIds) await this.cl.withMessage('Odebírám schvalovatele').removeApprover(this.myAccountId, this.invoiceId, itemIds);
		await this.reloadInvoice();
	}

	// Vrací seznam id schvalovacích skupin pokud je možné odebrat schvalovatele, nebo false pokud ne
	checkRemoveApprover(item: InvoiceItem, approverId: number): false|number[]
	{
		const groupIds = [];
		const step = this.approvingSchemas[item.approving.approvingSchemaId].steps.find(s => s.id == item.approving.currentStepId);
		for(const group of step.groups) {
			const cc = item.approving.approvers[group.id].filter(a => a != approverId).length;
			if (cc < group.minimalApprovers) return false;
			groupIds.push(group.id);
		}
		return groupIds;
	}

	protected async setState(state : string, entityType : ApprovingEntity) {
		const entityIDs = entityType === "invoice"
			? [<SetStateUid>{
				itemId: this.invoice.id,
				entity: 'invoice',
				approvingId: this.invoice.approving.approvingId
			}]
			: this.getCheckedItems().map(item => <SetStateUid>{
				itemId: item.approving.invoiceItemId,
				entity: 'invoiceItem',
				approvingId: item.approving.approvingId
			});

		await this.cl.setState(
			entityIDs,
			state,
			this.getComment()
		);
		this.reloadInvoice();
	}

	public async bSetApprover_click() {
		await this.cl.changeApprover(this.getApprovingItemIds(), this.muNamedWidget.cApprovers.muFetchData(), this.getComment());
		this.reloadInvoice();
	}

	/* public async bReopen_click() {
		await this.cl.reopen(this.getApprovingItemIds(), this.getComment());
		this.reloadInvoice();
	}

	public bAddComment_click() {

	}

	public bCloseApproving_click() {
		this.openApproving(false);
	} */

	public bReload_click() {
		this.reloadInvoice();
	}

	public async reloadInvoice(id : number|null = null) {
		if (id) this.invoiceId = id;
		// this.openApproving(false);
		await this.loadInvoice();
		this.updateForm();
	}

	protected openApproving(visible: boolean) {
		this.muVisible(visible, "itemApproving");
		// this.muVisible(true, 'pActionDetail');
		this.muVisible(false, "approvingSchema");
		// this.openSetApprovingSchemaList(false);
		// this.openOrgDivision(false);
	}

	public bOpenSetApprover_click() {
		this.setApprovingPhase("setApprover");
	}

	public bCloseSetApprover_click() {
		this.setApprovingPhase("actions");
	}

	protected setApprovingPhase(phase: "actions"|"setApprover") {
		this.muVisible(phase == "actions", "pActions");
		this.muVisible(phase == "setApprover", "pApproverSelector");
		this.muVisible(phase != "setApprover", 'pComment');
	}

	public selectAll(
		ev: Event|null,
		filter : "my-wait"|"rejected"|"noschema"|'noproduct'|'noproject'|null|number[],
		doCheck: boolean = true
	): InvoiceApprovalItem[]
	{
		const res: InvoiceApprovalItem[] = [];
		this.getItemWidgets()
			.forEach(iiw => {
				let checked = false;
				if (Array.isArray(filter)) {
					checked = filter.includes(iiw.invoiceItem.id);
				} else switch (filter) {
					case "rejected": checked = iiw.invoiceItem.approving.state == "rejected"; break;
					case "noschema":
						checked = iiw.canRunApproving(); /* invoiceItem.approving.state == "noschema"
							&& !!iiw.getOrgProjectId()
							&& (!!iiw.getOrgProductId() || !this.productRequired); */
						break;
					case "my-wait": checked = iiw.invoiceItem?.approving?.state == "wait" && iiw.isMy; break;
					case "noproduct": checked = iiw.invoiceItem.approving.state == "noschema"
						&& !iiw.getOrgProductId();
						break;
					case "noproject":
						checked = iiw.invoiceItem.approving.state == "noschema"
							&& !iiw.getOrgProjectId();
						break;
				}
				if (checked) res.push(iiw);
				if (doCheck) {
					iiw.ui.checked.checked = checked;
					iiw.checked_change();
				}
			});
		if (doCheck) this.updateForm();

		return res;
	}

	private getComment() : string {
		return this.ui.cInvComment.value;
	}

	public openSetApprovingSchemaList(isOpen : boolean) {
		if (isOpen)
		{
			this.muVisible(false, 'pActions');
			this.muVisible(false, 'pComment');
			this.cl.withMessage('Načítám schvalovací schémata').getApprovingSchemaList(false, true).then(data => {
				this.muBindData({approvingSchemaList: data});
				this.muVisible(true, 'pApprovingSchemaList');
			});
		} else this.muVisible(false, 'pApprovingSchemaList');
	}

	/* setApprovingSchemaId(id: number) {
		this.approvingSchemaId = id;
		this.muVisible(false, "pApprovingSchemaList");
		this.cl.getOrgDivisions().then(data => {
			const tree = this.muNamedWidget.cOrgDivision as TreeSelector;
			tree.bindTree(data);
			tree.collapseFromLevel(1);
			this.openOrgDivision(true);
		});
		this.muVisible(false, "bRunApproving");
	}

	cOrgDivision_change(ev, id) {
		this.muVisible(!!id, "bRunApproving");
	} */

	/* bRunApproving_click() {
		this.setApprovingSchema(this.approvingSchemaId, parseInt((this.muNamedWidget.cOrgDivision as TreeSelector).getValue()));
	} */

	createApproving(approvingSchemaId: number|null) {
		const data = this.getCheckedItemWidgets().map(
			iiw => {
				let opid = iiw.getOrgProjectId();
				opid = <number>(opid !== "withoutProject" ? opid : null);
				return {
					id: iiw.invoiceItem.id,
					approvingSchemaId: this.schemaByProjectDivision[iiw.getOrgDivisionId() + '-' + (opid ?? "")] || approvingSchemaId,
					orgDivisionId: iiw.getOrgDivisionId(),
					orgProjectId: opid,
					entityId: null,
					overheadCost: false
				};
			}
		);

		// @ts-ignore
		this.cl.withMessage('Spouštím schvalování').createApproving(
			'invoiceItem', // this.currentEntity,
			data
		).then((res) => {
			const allCount = res.length;
			let failedCount = 0;
			for(const resItem of res) {
				if (resItem.errors) {
					failedCount++;
					UiFlashMessage.instance.add("Nepovedlo se spustit schvalovani: " + resItem.errors.join(", "));
				}
			}
			if (allCount > failedCount) UiFlashMessage.instance.add((failedCount ? "Ostatním" : "Vybraným") + " položkám bylo nastaveno schvalovací schéma.");
			this.openApproving(false);
			this.openInvItemSelectSchema(false);
			this.reloadInvoice();
		});
	}
	/* setApprovingSchema(id: number, orgDivisionId : number) {
		//
		this.cl.createApproving(
			this.currentEntity,
			this.currentEntity === "invoiceItem" ? this.getApprovingItemIds() : [ this.invoice.id ],
			id,
			null,
			orgDivisionId
		).then(() => {
			UiFlashMessage.instance.add("Vybraným položkám bylo nastaveno schvalovací schéma.");
			this.openApproving(false);
			this.reloadInvoice();
		});
	} */

	bOpenSetApprovingSchemaList_click() {
		this.openSetApprovingSchemaList(true);
	}

	public showApprovingSchema(schemaId : number, itemId : number|null|"invoice", inApproving : boolean) {
		if (schemaId) {
			this.openApproving(true);
			this.muVisible(true, "approvingSchema");
			this.currentItemId = itemId;
			this.muNamedWidget.approvingSchema.muBindData(this.approvingSchemas[schemaId]);
			// this.set
			/* if (!inApproving) { // schovej zbytečnosti
				this.muVisible(false, 'pActionDetail');
			} */
		}
	}

	public getCurrentApproving(): InvoiceItemApproval {
		return this.currentItemId === "invoice"
			? this.invoice.approving
			: this.invoice.items.find(inv => inv.id == this.currentItemId).approving;
	}

	public getAccountsForGroupId(id : number) {
		/* const ids = this.currentItemId === "invoice"
			? (this.invoice.approving.approvers[id] || [])
			: this.invoice.items.find(inv => inv.id == this.currentItemId).approving.approvers[id]; */
		const ids = this.getCurrentApproving()?.approvers[id] || [];
		const accounts = [];
		for(let accountId of ids) {
			accounts.push(this.accounts[accountId.toString()]);
		}
		// console.log([ids, accounts]);
		return accounts;
	}

	public isCurrentStep(stepNum : number) {
		const approving = this.currentItemId === "invoice"
			? this.invoice.approving
			: this.invoice.items.find(inv => inv.id == this.currentItemId).approving

		return approving.currentStep == stepNum && approving.state == "wait";
	}

	private openOrgDivision(visible: boolean) {
		this.muVisible(visible, "pOrgDivision");
		if (visible) {

		}
	}

	bInvSelectSchema_click() {
		this.approveItems(this.invoice);
	}

	bInvApprove_click() {
		this.setState("accepted", "invoice");
	}

	bInvReject_click() {
		this.setState("rejected", "invoice");
	}

	bInvApprovingDetail_click() {
		this.showApprovingSchema(this.invoice.approving.approvingSchemaId, "invoice", false);
	}

	/* bindAttachList() {
		this.cl.getAttachesFotTicketAndRelated(this.ticketId).then(
			data => this.muBindData({attachList: data})
		);
	}

	showAttach(id: number) {
		this.cl.getAttachDetail(id, this.ticketId).then(
			data => {
				this.ui.preview.innerHTML = data;
				this.muVisible(true, 'bClosePreview');
			}
		);
	}

	bClosePreview_click() {
		this.ui.preview.innerHTML = '';
		this.muVisible(false, 'bClosePreview');
	} */

	public bindItems(items: any[]) {
		this.muClear("items");
		// this.muWidgetFromTemplate("invoiceItemHeader", "items");
		for(const item of items) {
			const w = this.muWidgetFromTemplate("invoiceItem", "items") as unknown as InvoiceApprovalItem;
			w.initOrgProjectId = item.orgProjectId;
			w.muBindData(item);

		}
		this.sumWidget = this.muWidgetFromTemplate("invoiceItemFooter", "items");
		this.updateSums();
	}

	updateSelectedValues(values : InvoiceApprovalItemValues) {
		const selected = this.getItemWidgets().filter(iiw => iiw.isChecked());
		selected.map(iiw => iiw.updateValues(values, false));
	}

	forkItem(invoiceApprovalItem: InvoiceApprovalItem) {
		this.forkItemDialog(invoiceApprovalItem);
	}

	private async forkItemDialog(invoiceApprovalItem: InvoiceApprovalItem) {
		// this.muVisible(true, "forkItemDialog");
		// (this.muNamedWidget.forkItemDialog as ForkItemDialog).loadItem(invoiceApprovalItem);
		const w = this.openInModal('UiInvoiceSplitItem', null, {
			fullPrice: invoiceApprovalItem.ui.cUnitPrice.valueAsNumber,
			fullQuantity: invoiceApprovalItem.ui.cQuantity.valueAsNumber,
			name: invoiceApprovalItem.ui.cName.value,
		}) as UiInvoiceSplitItem;
		invoiceApprovalItem.setMarked(true);
		const res = await w.savedPromise;
		invoiceApprovalItem.setMarked(false);
		// console.log(res);
		if (res && res.parts.length > 1) {
			const oldItemData = invoiceApprovalItem.muFetchData();
			let i = res.parts.length;
			for(const newValue of res.parts.reverse()) {
				const k = res.type == "price" ? "unitPrice" : "quantity";
				const v = res.type == "price" ? newValue * 100 : newValue;
				i--;
				if (i) {
					const newItemData = { ... oldItemData, id: null, orgProjectId: null, [k]: v };
					this.muWidgetFromTemplate(
						"invoiceItem",
						"items",
						{},
						"after",
						invoiceApprovalItem.container
					).muBindData(newItemData);
				} else {
					invoiceApprovalItem.muBindData({ [k]: v });
				}
			}

		}
	}

	doForkItem(invoiceApprovalItem: InvoiceApprovalItem, changes: { forkBy: "price" | "quantity"; name: string; value: number }) {
		const oldItemData = invoiceApprovalItem.muFetchData();
		const newItemData = { ... oldItemData, name: changes.name, id: null, orgProjectId: null };
		if (changes.forkBy == "quantity") {
			newItemData.quantity = changes.value;
			oldItemData.quantity -= changes.value;
		} else {
			newItemData.unitPrice = changes.value * 100;
			oldItemData.unitPrice -= changes.value * 100;
		}
		invoiceApprovalItem.muBindData(oldItemData);
		this.muWidgetFromTemplate(
			"invoiceItem",
			"items",
			{},
			"after",
			invoiceApprovalItem.container
		).muBindData(newItemData);
		this.closeModal("forkItemDialog");
	}

	fetchInvoice() {
		return this.getItemWidgets().map(iiw => iiw.muFetchData());
	}

	async bSaveAndApprove_click() {
		const res = await this.doSave(true);
	}

	bSave_click() {
		this.doSave(false);
	}

	doSave(autoApprove: boolean, reload = true)
	{
		this.setIsSaved();
		return this.cl.withMessage('Ukládám položky').updateInvoiceItems(
			this.getItemWidgets().map(iiw => iiw.muFetchData()),
			this.invoiceId,
			this.ticketId,
			autoApprove,
			true // vynutit spustení schvalování
		).then(data => {
			const res = this.callMethodInFirstAncestors('invoiceChanges', data.changes) as TicketEventRes;
			if (res?.action === "reloadNext") {
				return;
			} else {
				// reload bez změny požadavku
				this.setIsSaved();
				if (reload) this.callMethodInFirstAncestors('reloadTicketAndList');
			}
			this.bindInvoiceData(data);
			this.updateForm();
		});
	}

	private loadApprovingSchemas() {
		this.ui.approvingSchemaList.classList.toggle("loading-data", true);
		this.cl.getApprovingSchemaList(false, true).then(data => {
			this.muBindData({approvingSchemaList: data});
			this.ui.approvingSchemaList.classList.toggle("loading-data", false);
		});
	}

	/* createApproving(approvingSchemaId: number) {
		this.cl.createInvoiceItemApproving(
			this.invoiceId,
			this.getCheckedItems().map(ii => ii.id),
			approvingSchemaId
		).then(res => {
			this.reloadInvoice();
			this.openInvItemSelectSchema(false);
		});
	} */
	public updateSums() {
		if (!this.sumWidget) return;
		const sums = this.getItemWidgets().reduce(
			(previousValue, currentValue) => {
				const data = currentValue.computePrices();
				previousValue.price += data.price;
				previousValue.vatPrice += data.vatPrice;
				previousValue.vatPriceCurrency += data.vatPriceCurrency;

				return previousValue;
			},
			{ price: 0, vatPrice: 0, vatPriceCurrency: 0 }
		)
		this.sumWidget.muBindData(sums);
		this.muBindData(sums);
	}

	async bInvRequireProduct_click() {
		await this.doSave(false);
		await this.cl.requireProducts(this.ticketId, this.invoiceId);
		await this.loadInvoice();
	}

	protected getMyWaitItems(): InvoiceApprovalItem[] {
		return this.selectAll(null, "my-wait", false);
	}

	protected async selectItems(title: string, operation: string): Promise<{note:string, items: InvoiceApprovalItem[]}|null>
	{
		await this.saveIfNew();

		const res = await (this.openInModal<UiInvoiceApprovingItemSelector>(
			'UiInvoiceApprovingItemSelector',
			title,
			{
				items: this.getMyWaitItems().map(w => w.muFetchData()),
				operationName: operation
			}
		) as UiInvoiceApprovingItemSelector).savedPromise;

		return (res && res.itemIds.length)
			? {
				items: this.getItemWidgets().filter(item => res.itemIds.includes(item.muFetchData().id)),
				note: res.note
			}
			: null

	}

	async bInvItemRejectDialog_click() {
		const res = await this.selectItems("Zamítnutí položek", "Zamítnout");

		if (res === null) return;

		await this.cl.setState(
			res.items.map(item => ({
				itemId: item.invoiceItem.approving.invoiceItemId,
				entity: 'invoiceItem',
				approvingId: item.invoiceItem.approving.approvingId
			})),
			"rejected",
			res.note
		);
		await this.reloadInvoice();
	}

	async bInvItemCancelDialog_click() {
		const res = await this.selectItems("Předat schvalování někomu jinému", "Není moje");

		if (res && res.items.length) {
			await this.invoiceItemsCancel(res.items);
		}
	}

}

type InvoiceApprovalItemField = "orgProductId"|"orgProjectId"|"vat"|"orgDivisionId";
type InvoiceApprovalItemValues = Partial<Record<InvoiceApprovalItemField, any>>;

export class InvoiceApprovalItem extends BaseMuWidget
{
	public inApproving : boolean = false;
	// @ts-ignore
	public invoiceItem: InvoiceItem;
	public isMy : boolean = false;
	public initOrgProjectId: number | null = null;
	private allOrgDivisions: any[];
	public name: string = "";

	beforeIndex() {
		this.muAppendContent(/*html*/`<div class="invoice-approval--item" mu-id="main">
			<div class="grid-column-s2">
				<input type="checkbox" mu-id="checked" mu-bind="checked" />
				<span mu-id="bApproving"></span>
				<span class="icon-info-b cursor-pointer" mu-id="bDetails"></span>
			</div>
			<div class="text-right">Množství</div>
			<div class="text-right">Jedn.</div>
			<div class="text-right">Jedn. cena</div>
			<div class="text-right">DPH %</div>
			<div class="text-right">Základ</div>
			<div class="text-right">DPH částka</div>
			<div class="text-right">Celkem</div>
		
			<div>Název</div>
			<div><input type="text" mu-id="cName" mu-bind="name" class="form-control" /></div>
			<div><input type="number" mu-id="cQuantity" mu-bind="quantity" step="0.01" class="form-control" /></div>
			<div><input type="text" mu-id="cUnit" mu-bind="unit" class="form-control" /></div>
			<div><input type="number" mu-id="cUnitPrice" mu-bind="unitPrice|priceI100::value|priceI100r" step="0.01" class="form-control" /></div>
			<div><input type="number" mu-id="cVat" mu-bind="vat" class="form-control" /></div>
			<div mu-id="price" mu-bind="price|priceV" class="number"></div>
			<div mu-id="vatPrice" mu-bind="vatPrice|priceV" class="number"></div>
			<div mu-id="vatPriceCurrency" mu-bind="vatPriceCurrency|priceV" class="number"></div>
		
			<div>Středisko</div>
			<div><div mu-widget="UiTomSelect" mu-id="cOrgDivision" mu-bind="orgDivisionId" mu-params='{"valueField":"id","labelField":"title"}'></div></div>
			<div class="grid-column-s5"></div>
			<div class="grid-column-s2 text-align-right">
				<span class="a" mu-id="bFork">Rozdělit položku</span>
			</div>
		
			<div>Projekt</div>
			<div>
				<!-- <div mu-widget="TreeSelector" mu-id="cOrgProject" mu-bind="orgProjectId" mu-params='{"inModal":true}'></div> -->
				<div mu-widget="UiTomSelect" mu-id="cOrgProject" mu-bind="orgProjectId" mu-params='{"valueField":"id","labelField":"title"}'></div>
				<span class="icon-before-alert" mu-id="changeProjectInfo" style="display: none">Změnil se projekt, schvalování bude znovu spuštěno.</span>
			</div>
			<div><label class="checkbox-inline">
				<input type="checkbox" mu-bind="withoutProject" mu-id="cWithoutProject" />
				Bez projektu
			</label></div>
			<div class="grid-column-s3"></div>
			<div class="grid-column-s3 grid-row-s2">
				<div mu-bind="approving|getComments:@foreach">
					<div mu-widget="." mu-template="comment">
						<span mu-bind="note:@visible" class="icon-comment"></span>
						<span mu-bind='state|prepend("icon-"):className'></span>
						<span mu-bind="accountId|getAccountName"></span>
						<span mu-bind="note" class="invoice-approval--approving-schema--step--account--note"></span>
					</div>
				</div>
			</div>
		
			<div>Produkt</div>
			<!-- <div><div mu-widget="TreeSelector" mu-id="cOrgProduct" mu-bind="orgProductId" mu-params='{"inModal":true}'></div></div> -->
			<div><div mu-widget="UiTomSelect" mu-id="cOrgProduct" mu-bind="orgProductId" mu-params='{"valueField":"id","labelField":"title"}'></div></div>
		
		</div>`)
	}

	// @ts-ignore
	muParent : InvoiceApproval;
	// @ts-ignore
	ui : MuUi<{
		cQuantity : HTMLInputElement,
		cUnit : HTMLInputElement,
		cUnitPrice : HTMLInputElement,
		cVat : HTMLInputElement,
		cName : HTMLInputElement,
		checked : HTMLInputElement,
		price : HTMLInputElement,
		vatPrice : HTMLInputElement,
		vatPriceCurrency : HTMLInputElement,
		cWithoutProject: HTMLInputElement,
		cOverheadCost: HTMLInputElement,
	}>;
	// @ts-ignore
	muNamedWidget : MuNamedWidgets<{
		cOrgDivision : UiTomSelect,
		cOrgProduct : UiTomSelect,
		cOrgProject : UiTomSelect, // TreeSelector,
	}>;
	public oldOrgProductId: number = -1;

	public getOrgProjectId(): number|null|"withoutProject" {
		const v = this.ui.cWithoutProject.checked
			? "withoutProject"
			: this.muNamedWidget.cOrgProject.getValue();
		// @ts-ignore
		return (v === null || v === "withoutProject") ? v : parseInt(v);
	}

	public setOrgProjectId(value: number|null|"withoutProject"): void {
		this.updateValues({
			orgProjectId: value
		});
	}

	public getOrgDivisionId(): number|null {
		const v = this.muNamedWidget.cOrgDivision.getValue();
		return v === null ? null : parseInt(v);
	}

	public getOrgProductId(): number|null {
		const v = this.muNamedWidget.cOrgProduct.getValue();
		return v === null ? null : parseInt(v);
	}

	override afterIndex() {
		this.approvingLayout(this.inApproving);
	}

	/* protected muAfterBindData(data: any) {
		this.computePrices();
	} */

	override muBindData(invoiceItem: Partial<InvoiceItem>) {
		const invoiceItemBindData = { ... invoiceItem };
		if (invoiceItemBindData.orgProjectId === "withoutProject") {
			invoiceItemBindData.orgProjectId = null;
			invoiceItemBindData.withoutProject = true;
		}
		if ('orgProductId' in invoiceItem) this.oldOrgProductId = invoiceItem.orgProductId
		super.muBindData(invoiceItemBindData);
		this.invoiceItem = { ...this.invoiceItem, ...invoiceItem };
		if (!this.invoiceItem.approving) { // @ts-ignore
			this.invoiceItem.approving = {
				state: "noschema", // invoiceItem.orgProductId ? "noschema" : "noproduct",
				approverIds: [],
			};
		}
		// Schvalování
		// this.ui.approvalIcon.className = 'icon-' + invoiceItem.approving.state;
		// (this.ui.bApproving as any).className = 'icon-' + invoiceItem.approving.state;
		this.isMy =	this.invoiceItem.approving.approverIds?.includes(this.muParent.myAccountId);
		if (this.isMy)
			this.container.classList.add("for-approving");
		this.muParent.orgDivisionPromise.fetch().then(ls => {
			this.allOrgDivisions = ls;
			this.muNamedWidget.cOrgDivision.bindItems(ls);
			// (this.muNamedWidget.cOrgDivision as TreeSelector).bindTree(ls);
			// až po nabindování stredisek at zna strukturu
			setTimeout(() => this.bindProjectTree(), 200);
		});
		this.muParent.orgProductPromise.fetch().then(ls => this.muNamedWidget.cOrgProduct.bindItems(ls));
		this.computePrices();
	}

	async bindProjectTree() {
		const projects = await this.muParent.orgProjectPromise.fetch();
		/* const orgDivisionId = this.muNamedWidget.cOrgDivision.value
		const orgDivisionIds = orgDivisionId ?
			[ orgDivisionId, ...Utils.getRecursiveItems(
				await this.muParent.orgDivisionPromise.fetch(),
				orgDivisionId
			) ] : null; */
		const orgDivisionIds: null|[] = null;

		// (this.muNamedWidget.cOrgDivision as TreeSelector).getSelectedItemRecursive().map(i => i.id);
			/* (this.muNamedWidget.cOrgProject as TreeSelector).bindTree(
				!!orgDivisionIds.length
				? ls.filter(od => orgDivisionIds.indexOf(od.orgDivisionId) > -1)
				: ls
			); */
		this.muNamedWidget.cOrgProject.bindItems(
			(orgDivisionIds && orgDivisionIds.length
				? projects.filter((od:any) => orgDivisionIds.indexOf(od.orgDivisionId) > -1)
				: projects),
			true
		);
	}

	override muFetchData(): any {
		return {
			...super.muFetchData(),
			id: this.invoiceItem.id,
			orgProjectId: this.getOrgProjectId(),
		}
	}

	public approvingLayout(inApproving: boolean) {
		// (this.container.firstElementChild as HTMLElement).style.visibility = inApproving ? "hidden" : null;
		// (this.container.lastElementChild.previousElementSibling as HTMLElement).style.visibility = inApproving ? "hidden" : null;
	}

	public isChecked() : boolean {
		return (this.ui.checked as HTMLInputElement).checked;
	}

	public checked_change() {
		this.muParent.updateForm();
		this.container.classList.toggle('selected', this.ui.checked.checked);
	}

	/* public bApproving_click() {
		this.muParent.approveItems([this.invoiceItem]);
	} */

	public async bDetails_click() {
		if (this.invoiceItem.approving?.approvingSchemaId) {
			this.muParent.showApprovingSchema(this.invoiceItem.approving?.approvingSchemaId, this.invoiceItem.id, this.inApproving);
		} else {
			console.log(this.invoiceItem);
			const res = await this.muParent.cl.findApprovingSchemaForItem(this.invoiceItem);
			flashInfo("Schvalování není ještě spuštěno. "
				+ (res
					? "Bude použito schvalovací schéma " + res
					: "Pro tuto položku nebylo nalezeno vhodné schvalovací schéma"
				))
		}
	}

	visibleCheckedIfState(state: InvoiceState|null) {
		let vis : boolean = state == null || state == this.invoiceItem?.approving?.state;
		if (vis) {
			switch (this.invoiceItem?.approving?.state) {
				case "accepted": vis = false; break;
				case "wait": vis = this.isMy; break;
				case "rejected": vis = false; // true;
			}
		}
		this.ui.checked.style.visibility = vis ? 'visible' : 'hidden';
		/* this.muVisible(
			vis,
			'checked'
		); */
	}

	cOrgProduct_changeValue(ev: Event) {
		//todo:Nová verze MuWidget
		const item = this.muNamedWidget.cOrgProduct.valueOption;
		if (item) {
			this.updateValues(item
				? {orgProductId: item.id, vat: item.vat}
				: {orgProductId: item.id}
			);
			this.muParent.updateForm();
			this.muParent.updateSums();
		}
	}

	cOrgProject_changeValue(ev: Event) {
		const changes: any = {
			orgProjectId: this.getOrgProjectId(),
		};
		if (this.muNamedWidget.cOrgProject.valueOption)
			changes.orgDivisionId = this.muNamedWidget.cOrgProject.valueOption.orgDivisionId;
		this.updateValues(changes);
		this.muParent.updateForm();
	}

	cWithoutProject_change() {
		this.updateValues({orgProjectId: this.getOrgProjectId()});
		this.muParent.updateForm();
	}

	cOrgDivision_changeValue(ev: Event) {
		//todo:Nová verze MuWidget
		this.updateValues({orgDivisionId: this.muNamedWidget.cOrgDivision.value });
		this.bindProjectTree();
	}

	updateValues(values: InvoiceApprovalItemValues, updateOthers : boolean = true, updateSelf: boolean = true) {
		if (updateSelf) {
			if ("vat" in values) this.ui.cVat.value = values.vat;
			if ("orgProductId" in values) this.muNamedWidget.cOrgProduct.setSelected(values.orgProductId, false);
			if ("orgProjectId" in values) {
				if (values.orgProjectId !== "withoutProject") this.muNamedWidget.cOrgProject.setSelected(values.orgProjectId, false);
				this.ui.cWithoutProject.checked = values.orgProjectId === "withoutProject";
			}
			if ("orgDivisionId" in values) this.muNamedWidget.cOrgDivision.setSelected(values.orgDivisionId, false);
		}
		if (this.isChecked() && updateOthers) this.muParent.updateSelectedValues(values);
		this.computePrices();
	}

	cQuantity_change() {
		this.computePrices();
		this.muParent.updateSums();
	}

	cUnitPrice_change() {
		this.computePrices();
		this.muParent.updateSums();
	}

	cVat_change() {
		this.computePrices();
		this.muParent.updateSums();
	}

	computePrices(): { price: number, vatPrice: number, vatPriceCurrency: number }  {
		// const values = this.muFetchData();
		const data: any = {};
		data.price = parseFloat(this.ui.cQuantity.value) * parseFloat(this.ui.cUnitPrice.value);
		data.vatPrice = data.price * (parseFloat(this.ui.cVat.value) / 100);
		data.vatPriceCurrency = data.vatPrice + data.price;
		this.ui.price.innerText = MuBinder.filters.priceV(data.price);
		this.ui.vatPrice.innerText = MuBinder.filters.priceV(data.vatPrice);
		this.ui.vatPriceCurrency.innerText = MuBinder.filters.priceV(data.vatPriceCurrency);
		if (this.invoiceItem) {
			const state = (this.invoiceItem.approving.state == "noschema"
					? (this.canRunApproving()
						? "noschema"
						: "noproject"
					)
					: this.invoiceItem.approving.state
			);
			(this.ui.bApproving as any).className = "icon-" + state;

			const disabled = !this.isEditable();
			this.ui.cName.disabled = disabled;
			this.ui.cQuantity.disabled = disabled;
			this.ui.cUnit.disabled = disabled;
			this.ui.cUnitPrice.disabled = disabled;
			this.ui.cVat.disabled = disabled;
			this.ui.cWithoutProject.disabled = disabled;
			// this.ui.cOverheadCost.disabled = disabled;
			this.muNamedWidget.cOrgDivision.setDisabled(disabled);
			this.muNamedWidget.cOrgProject.setDisabled(disabled || this.ui.cWithoutProject.checked);
			// this.muNamedWidget.cOrgProduct.setDisabled(disabled);
			/* console.log([
				this.invoiceItem.id,
				this.invoiceItem.approving.state,
				this.getOrgProjectId(),
				this.getOrgProductId(),
				(this.ui.bApproving as any).className
			]); */
			this.muVisible(
				this.initOrgProjectId && this.invoiceItem.approving.state == "wait" && this.initOrgProjectId != this.getOrgProjectId(),
				'changeProjectInfo'
			)
			this.container.classList.toggle('invoice-approval--item__no-project', !this.getOrgProjectId());
			/* (this.ui.cOrgProject as HTMLElement).style.visibility = this.ui.cWithoutProject.checked
				? "hidden"
				: "visible"; */
		}
		return data;
	}

	isEditable() {
		return !(["accepted", "rejected"].includes(this.invoiceItem?.approving?.state));
	}

	bFork_click() {
		this.muParent.forkItem(this);
	}

	canRunApproving(): boolean {
		return this.invoiceItem.approving.state == "noschema"
			&& !!this.getOrgProjectId()
			&& (!!this.getOrgProductId() || !this.muParent.productRequired);
	}

	getComments(approving: InvoiceItemApproval) {
		return approving.approvals
			? approving.approvals.filter(a => a.note || a.state === "rejected")
			: [];
	}

	setMarked(state: boolean) {
		this.ui.main.classList[state ? "add" : "remove"]('invoice-approval--item__marked');
	}
}

export class ApprovingSchemaListItem extends BaseMuWidget
{
	public id : number;

	name_click() {
		// (this.muParent as InvoiceApproval).setApprovingSchemaId(this.id);
		(this.muParent as InvoiceApproval).createApproving(this.id);
	}

	afterIndex() {

	}

	bEdit_click() {
		this.name_click();
	}
}

/* export class ApprovingSchemaGroup extends BaseMuWidget {
	protected master(): InvoiceApproval {
		return this.muParent.muParent.muParent as InvoiceApproval;
	}

	public getAccountsForGroupId(id: number) {
		return this.master().getAccountsForGroupId(id);
	}
} */

export class ApprovingSchemaGroupAccount extends BaseMuWidget {
	protected master(): InvoiceApproval {
		return this.muParent.muParent.muParent.muParent as InvoiceApproval;
	}

	public isMyAccount(id : number) {
		return this.master().myAccountId == id;
	}

	public getAccountStateIcon(accountId) {
		//todo: reverse
		const approval = (this.master().getCurrentApproving()?.approvals || []).reverse().find(a => a.accountId == accountId && a.approvingSchemaStepGroupId);
		// this.muParent.muParent.stepId
		return 'icon-' + InvoiceApproval.stateIcons[approval?.state ?? 'wait'];
	}

	public getAccountStateNote(accountId) {
		//todo: reverse
		const approval = (this.master().getCurrentApproving()?.approvals || []).reverse().find(a => a.accountId == accountId && a.approvingSchemaStepGroupId);
		// this.muParent.muParent.stepId
		return approval?.note ?? '';
	}
}

export class ForkItemDialog extends BaseMuWidget {

	private invoiceApprovalItem: InvoiceApprovalItem;

	muParent : InvoiceApproval;

	private lastValue: Record<ForkBy, any> = {
		price: 0,
		quantity: 0
	};

	afterIndex() {
		this.muVisible(false, "itemsData");
	}

	changeForkBy() {
		const forkBy = this.getForkBy();
		this.muVisible(!!forkBy, "itemsData");
		this.bindForkBy(forkBy);
		this.ui.newValueV.focus();
	}

	getForkBy() : ForkBy|null {
		return this.ui.cForkByPrice.checked
			? "price"
			: (
				this.ui.cForkByQuantity .checked
					? "quantity"
					: null
			)
	}

	loadItem(invoiceApprovalItem: InvoiceApprovalItem) {
		this.invoiceApprovalItem = invoiceApprovalItem;
		this.ui.unitPriceOriginal.innerText = MuBinder.filters.priceV(this.invoiceApprovalItem.ui.cUnitPrice.value);
		this.ui.quantityOriginal.innerText = MuBinder.filters.priceV(this.invoiceApprovalItem.ui.cQuantity.value);
		this.ui.cName.value = this.invoiceApprovalItem.ui.cName.value;
		this.muVisible(!!this.getForkBy(), "itemsData");
	}

	getOrignalValue() : number {
		return this.getForkBy() === "price"
			? parseFloat(this.invoiceApprovalItem.ui.cUnitPrice.value)
			: parseFloat(this.invoiceApprovalItem.ui.cQuantity.value);
	}

	bindForkBy(forkBy : ForkBy) {
		const lastForkBy = this.getForkBy();
		if (!!lastForkBy) this.lastValue[lastForkBy] = this.ui.newValueV.value;
		this.ui.newValueR.max = this.ui.newValueV.max = this.getOrignalValue();
		this.ui.originalValue.innerText = MuBinder.filters.priceV(this.ui.newValueV.max);
		this.ui.newUnit.innerText = this.ui.oldUnit.innerText = forkBy === "price"
			? ""
			: this.invoiceApprovalItem.ui.cUnit.value;

		this.setValue(this.lastValue[forkBy]);
	}

	newValueR_change(ev: Event) {
		this.setValue(ev.target.value);
	}

	newValueV_change(ev: Event) {
		this.setValue(ev.target.value);
	}

	private setValue(value: string) {
		this.ui.newValueR.value = this.ui.newValueV.value = value;
		this.ui.oldValue.innerText = MuBinder.filters.priceV(this.getOrignalValue() - parseFloat(value));
	}

	/* bFork_click() {
		this.muParent.doForkItem(this.invoiceApprovalItem, {
			value: this.ui.newValueV.value,
			forkBy: this.getForkBy(),
			name: this.ui.cName.value
		});
	} */
}

export type ForkBy = "price"|"quantity";

export type InvoiceApprovalFormMode = "complete"|"schema"|"approving";

/* export class AttachesListItem extends BaseMuWidget {

	muParent : InvoiceApproval;

	id: number;

	name_click() {
		this.muParent.showAttach(this.id);
	}

	protected muAfterBindData(data: any) {
		this.container.style.display =
			data.contentType.toLowerCase() == 'application/pdf'
			? '' : 'none';
	}
} */

export class UiInvoiceSplitItem extends BaseMuWidget {
	// @ts-ignore
	private spResolve: (value: (PromiseLike<{ type: "quantity" | "price"; parts: number[] }| null> | { type: "quantity" | "price"; parts: number[] }|null)) => void;
	// @ts-ignore
	private spReject: (reason?: any) => void;
	public savedPromise: Promise<{ type: "quantity" | "price"; parts: number[] }|null> = new Promise<{type:"quantity"|"price",parts:number[]}|null>(
		(resolve,reject) => {
			this.spResolve = resolve;
			this.spReject = reject;
		});
	// @ts-ignore
	public fullPrice: number;
	// @ts-ignore
	public fullQuantity: number;

	public getFullValue(): number
	{
		return this.type === "price" ? this.fullPrice : this.fullQuantity;
	}

	public name: string = "";

	// @ts-ignore
	private firstPart: MuWidget;
	private type: "price" | "quantity" | null = null;

	beforeIndex() {
		this.muAppendContent(`<div class="invoice-split-item text-center">
			<strong>Rozdělení položky <span mu-id="name"></span></strong>
			<div class="checkbox">
				<label>
					<input type="radio" mu-id="cPrice" mu-name="splitBy" value="price" mu-change="onChangeType" /> Rozdělit částku za jednotku (<span mu-id="fullPrice"></span>).
				</label>
				<label>
					<input type="radio" mu-id="cQuantity" mu-name="splitBy" value="quantity" mu-change="onChangeType" /> Rozdělit množství (<span mu-id="fullQuantity"></span>).
				</label>		
			</div>	
			<!-- <div mu-id="pPrice">
			</div>
			<div mu-id="pQuantity">
			</div> -->
		</div>
		<div class="display-grid-c2 gap-4px" mu-id="pSplit">
			<div class="text-right">
				Rozdělit <span mu-id="currentType"></spanmu>
			</div>
			<div mu-id="parts">
				<div mu-widget="." mu-template="item">
					<input type="number" mu-id="value" /><span class="icon-remove btn-icon" mu-id="bRemove"></span>
					<span class="invoice-split-item__inv-warning" mu-id="invWarning"></span>
				</div>
			</div>
			<div class="grid-column-s2 text-center">
				<span class="icon-before-add btn-icon" mu-id="bAdd">Přidat další rozdělení</span>
			</div>
			<div class="grid-column-s2 buttons">
				<span class="btn btn-primary icon-before-add" mu-id="bSave">Uložit rozdělení</span>
				<span class="btn btn-default icon-before-cancel" mu-id="bCancel">Storno</span>
			</div>
		</div></div>`)
	}

	afterIndex() {
		this.ui.fullPrice.innerText = MuBinder.filters.priceV(this.fullPrice);
		this.ui.fullQuantity.innerText = MuBinder.filters.priceV(this.fullQuantity);
		this.ui.name.innerText = this.name;
		this.setType(null);
	}

	addPart(first: boolean = false) {
		const w = this.muWidgetFromTemplate('item', 'parts', {
			bRemove_click: () => {
				w.muRemoveSelf();
				this.calculate();
			},
			value_input: (ev: Event) => this.calculate(ev),
		});
		if (first) {
			w.ui.value.disabled = true;
			w.muVisible(false, 'bRemove');
			this.firstPart = w;
		} else w.ui.value.focus();
		this.calculate();
	}

	bAdd_click() {
		this.addPart();
	}

	bCancel_click() {
		this.muRemoveSelf();
		this.spResolve(null);
	}

	bSave_click() {
		this.muRemoveSelf();
		if (this.type) {
			this.spResolve({
				type: this.type,
				parts: this.getParts().filter(n => !!n)
			});
		} else this.spResolve(null);
	}

	private calculate(ev: Event|null = null) {
		const partsSum = this.getParts().reduce((s, c) => s + c);
		const diff = partsSum - this.getFullValue();
		this.firstPart.ui.value.valueAsNumber = (this.firstPart.ui.value.valueAsNumber || 0) - diff;
		for(const part of this.muGetChildWidgets('parts')) {
			part.muVisible(
				(part.ui.value.valueAsNumber >= 0) != (this.getFullValue() >= 0),
				"invWarning"
			);
			part.ui.invWarning.innerText = "Hodnota by měla být " + (this.getFullValue() > 0 ? "kladná" : "záporná") + ".";
		}
	}

	private getParts(): number[] {
		return this.muGetChildWidgets('parts').map(w => w.ui.value.valueAsNumber || 0);
	}

	pPrice_click() {
		this.setType("price");
	}
	pQuantity_click() {
		this.setType("quantity");
	}

	onChangeType(ev: Event) {
		// @ts-ignore
		this.setType(getRadioListSelectedValue(this.ui.cPrice));
	}

	private setType(type: "price"|"quantity"|null) {
		/* if (this.type === type) type = null;
		for (const t of ["Price", "Quantity"]) {
			this.muVisible(type === t.toLowerCase() || type === null, "p" + t);
			const newCh = type === t.toLowerCase();
			if (this.ui["c" + t].checked !== newCh)
				this.ui["c" + t].checked = newCh;
		} */

		this.muVisible(!!type, "pSplit");
		if (type != this.type) {
			this.muClear('parts');
			this.addPart(true);
			this.addPart();
		}
		if (type) {
			this.ui.currentType.innerText = {
				price: "cenu",
				quantity: "monžství",
			}[type];
		}
		this.type = type;
	}
}

export class UiInvoiceApprovingItemSelector extends BaseMuWidget {
	// @ts-ignore
	public items: any[];
	// @ts-ignore
	public operationName: string;
	public id: number|null = null;
	public savedPromise: Promise<null|InvoiceApprovingItemSelectorRes> = new Promise<InvoiceApprovingItemSelectorRes | null>(
		resolve => this.spResolve = resolve
	)
	// @ts-ignore
	private spResolve: (value: (PromiseLike<InvoiceApprovingItemSelectorRes | null> | InvoiceApprovingItemSelectorRes | null)) => void;

	beforeIndex() {
		this.muAppendContent(`
			<strong>Vyberte položky</strong>
			<div>
				<table class="table">
					<tbody mu-id="items" mu-bind="items::@foreach">
						<tr mu-template="item" mu-widget="." mu-bind="id::.id">
							<td>
								<div class="checkbox">
									<label>
										<input type="checkbox" mu-bind="checked" mu-id="checked" />
										<span mu-bind="name" class="flex-grow-1"></span>							
									</label>
								</div>
							</td>
							<td style="width: auto" class="number">
								<span mu-id="quantity" mu-bind="quantity"></span> &times;
								<span mu-id="unitPrice" mu-bind="unitPrice|priceV"></span>
							</td>
						</tr>
					</tbody>
				</table>
				<label mu-for="note">Komentář</label>
				<textarea mu-bind="note" mu-id="note" class="form-control"></textarea>
				<div class="buttons">
					<span class="btn btn-primary" mu-id="bSave" mu-bind="operationName"></span>
					<span class="btn btn-default icon-before-cancel" mu-id="bCancel">Storno</span>
				</div>
			</div>
		`);
	}

	afterIndex() {
		this.muBindData({ items: this.items, operationName: this.operationName});
	}

	bCancel_click() {
		this.spResolve(null);
		this.muRemoveSelf()
	}

	bSave_click() {
		const data = this.muFetchData();
		const itemIds = data.items.filter((item: any) => item.checked).map((item: any) => item.id);
		if (!itemIds.length) {
			alert("Není vybrána ani jedna položka.");
			return;
		}
		this.spResolve({
			itemIds,
			note: data.note
		});
		this.muRemoveSelf();
	}

}

export type InvoiceApprovingItemSelectorRes = {
	itemIds: number[],
	note: string,
}

export type FormOptions = {
	noApproving?: boolean,
	readOnly?: boolean,
}